import React, { useState } from "react";
import { useRouter } from "next/router";
import ContactFormExitStep1 from "@/component/shared/contactForm/contactFormStep1";
import ContactFormExitStep2 from "@/component/shared/contactForm/contactFormStep2";
import { FormProvider } from "@/component/shared/contactForm/formContext";

const DownloadPdfPage = ({blogPostID}) => {
  const router = useRouter();
  const { locale } = router;
  const [isVisible, setIsVisible] = useState(false);
  const [showNextStep, setShowNextStep] = useState(false);

  const handleButtonClick = () => {
    setIsVisible(true);
  };

  const closePopup = () => {
    setIsVisible(false);
    setShowNextStep(false);
  };

  const showSteps = () => {
    setShowNextStep(true);
  };

  const showFirstStep = () => {
    setShowNextStep(false);
  };

  return (
    <section>
      <div className="mb-2 mt-[-15px]">
        <button
          className="py-1 px-3 bg-brand text-white rounded-lg sm:text-sm"
          onClick={handleButtonClick}
        >
          Download Custom Templates
        </button>
      </div>

      {isVisible && (
        <div className="fixed z-[100] inset-0 flex items-center justify-center bg-black bg-opacity-50 sm:px-2">
          <div className="relative bg-white rounded-lg shadow-lg">
            <div
              className="absolute top-0.5 sm:top-0.5 right-1 cursor-pointer"
              onClick={closePopup}
            >
              <svg
                xmlns="https://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="24"
                height="24"
                fill="currentColor"
              >
                <path d="M11.9997 10.5865L16.9495 5.63672L18.3637 7.05093L13.4139 12.0007L18.3637 16.9504L16.9495 18.3646L11.9997 13.4149L7.04996 18.3646L5.63574 16.9504L10.5855 12.0007L5.63574 7.05093L7.04996 5.63672L11.9997 10.5865Z"></path>
              </svg>
            </div>

            {/* Content based on locale */}
            {locale === "en-in" && (
              <FormProvider>
                {!showNextStep ? (
                  <ContactFormExitStep1 showStep1={showSteps} />
                ) : (
                  <ContactFormExitStep2
                    showPrevStep={showFirstStep}
                    formType="GetInTouchNew"
                    blogPostID={blogPostID}
                  />
                )}
              </FormProvider>
            )}
          </div>
        </div>
      )}
    </section>
  );
};

export default DownloadPdfPage;
